/**
 * 指标卡片组件：标题 + 数值 + 图标 + 可选页脚。
 *
 * @module components/common/StatCard
 */
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import type { ReactNode } from 'react';

/** StatCard 属性。 */
export interface StatCardProps {
  /** 指标标题。 */
  title: string;
  /** 指标数值（任意节点）。 */
  value: ReactNode;
  /** 右上角图标。 */
  icon?: ReactNode;
  /** 强调色（MUI 颜色表达式）。 */
  color?: string;
  /** 页脚说明。 */
  footer?: ReactNode;
}

/**
 * 指标卡片。
 *
 * @param props 组件属性。
 * @returns JSX 元素。
 */
export default function StatCard({
  title,
  value,
  icon,
  color = 'primary.main',
  footer,
}: StatCardProps): JSX.Element {
  return (
    <Card sx={{ borderRadius: 3, height: '100%' }}>
      <CardContent>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="body2" color="text.secondary">
            {title}
          </Typography>
          {icon && <Box sx={{ color, display: 'flex' }}>{icon}</Box>}
        </Box>
        <Typography variant="h4" fontWeight={700} sx={{ mt: 1 }}>
          {value}
        </Typography>
        {footer && <Box sx={{ mt: 1 }}>{footer}</Box>}
      </CardContent>
    </Card>
  );
}
